<template>
  <div class="log">
    <basic-container>
      <div class="d-f align-c">
        <el-button
          type="primary"
          icon="el-icon-refresh"
          :loading="refreshLoading"
          @click="refreshRisk"
        >
          刷新风险
        </el-button>
        <span class="m-l-30">{{ refreshText }}</span>
        <span class="m-l-30">当前PE总数(待领取):{{ pendPeNum }}</span>
        <span class="m-l-30">当前活跃资源人数:{{ activeNum }}</span>
      </div>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        @on-load="getList"
        :header-cell-class-name="headerCell"
        :search.sync="search"
        @sort-change="sortChange"
        @search-reset="searchRest"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-update="update"
        @size-change="sizeChange"
        :cell-style="cellStyle"
        class="self_defined"
        @current-change="currentChange"
      >
        <template slot="sourceId" slot-scope="scope">
          <el-link
            type="primary"
            @click="
              tagClick(
                scope.row.sourceId,
                1,
                null,
                scope.row.orderId,
                scope.row.flowName,
                scope.row.flowLevel,
                scope.row.orderFlow,
                scope.row.orderFlowName,
              )
            "
          >
            {{ scope.row.sourceId }}
          </el-link>
        </template>
        <template slot="orderId" slot-scope="scope">
          <el-link
            type="primary"
            :class="{ green: scope.row.hasOperation === 1 }"
            @click="
              tagClick(
                scope.row.flowId,
                2,
                parseInt(scope.row.sortTime),
                scope.row.orderId,
                scope.row.flowName,
                scope.row.flowLevel,
                scope.row.orderFlow,
                scope.row.orderFlowName,
              )
            "
          >
            {{
              scope.row.autoType === 1
                ? scope.row.orderId
                : scope.row.orderId + '  (自动)'
            }}
          </el-link>
        </template>
        <template slot="projectStaus" slot-scope="scope">
          <div>
            {{
              tableOption.column[7]?.dicData?.find(
                (it) => it.value === scope.row.projectStaus,
              )
                ? tableOption.column[7]?.dicData?.find(
                    (it) => it.value === scope.row.projectStaus,
                  ).label
                : ''
            }}
            <span v-if="getStatus(parseInt(scope.row.sortTime))">
              ({{ getStatus(parseInt(scope.row.sortTime)) }})
            </span>
          </div>
        </template>
        <template slot="search">
          <el-input
            class="w-230"
            placeholder="轻任务订单号/客户名称/来源ID"
            size="mini"
            clearable
            v-model="search.text"
            @keyup.enter.native="refreshChange"
          ></el-input>
          <el-select
            class="m-l-15"
            style="width: 100px !important"
            size="mini"
            v-model="search.pmId"
            filterable
            clearable
            placeholder="请选择PM"
          >
            <el-option
              v-for="item in pmOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            class="m-l-15"
            style="width: 110px !important"
            size="mini"
            v-model="search.sortType"
            filterable
            clearable
            placeholder="请选择项目"
          >
            <el-option
              v-for="item in itemOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            class="m-l-15"
            style="width: 150px !important"
            size="mini"
            v-model="search.riskLevel"
            filterable
            clearable
            placeholder="请选择任务风险等级"
          >
            <el-option
              v-for="item in riskLevelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            class="m-l-15"
            style="width: 130px !important"
            size="mini"
            v-model="search.autoType"
            filterable
            clearable
            placeholder="请选择项目类型"
          >
            <el-option
              v-for="item in autoTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            class="m-l-15"
            style="width: 170px !important"
            size="mini"
            v-model="search.language"
            filterable
            clearable
            placeholder="请选择语种"
          >
            <el-option
              v-for="item in languageOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            class="m-l-15"
            style="width: 170px !important"
            size="mini"
            v-model="search.fieldCode"
            clearable
            placeholder="请选择领域"
          >
            <el-option
              class="p-lr-10"
              v-for="item in industryListArr"
              :key="item.fieldId"
              :label="item.fieldName"
              :value="item.fieldId"
            >
              {{ item.fieldName }}
            </el-option>
          </el-select>
          <el-select
            class="m-l-15"
            style="width: 170px !important"
            size="mini"
            v-model="search.qcId"
            clearable
            placeholder="请选择质控名称"
          >
            <el-option
              class="p-lr-10"
              v-for="item in processQcList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              {{ item.label }}
            </el-option>
          </el-select>
        </template>
        <template slot="menuLeft">
          <el-checkbox
            class="p-l-10"
            v-model="search.pending"
            @change="pendingChange"
          >
            只看待领取
          </el-checkbox>
        </template>
        <template slot="pmName" slot-scope="scope">
          <span>
            {{
              pmOptions.find((it) => it.username === scope.row.pmName)
                ? pmOptions.find((it) => it.username === scope.row.pmName).label
                : ''
            }}
          </span>
        </template>
        <template slot="slan" slot-scope="scope">
          <span>
            {{ $sysLan.get(scope.row.slan) }}-{{ $sysLan.get(scope.row.tlan) }}
          </span>
        </template>
        <template slot="startTime" slot-scope="scope">
          <span>
            {{ scope.row.startTime ? formatDate(scope.row.startTime) : '--' }}
          </span>
        </template>
        <template slot="limitTime" slot-scope="scope">
          <span>
            {{ scope.row.limitTime ? formatDate(scope.row.limitTime) : '--' }}
          </span>
        </template>
        <template slot="totalNum" slot-scope="scope">
          <span
            v-if="
              scope.row.flowLevel == 1 ||
              scope.row.flowLevel == 3 ||
              scope.row.flowLevel == 5
            "
          >
            {{
              scope.row.flowName === 'PE'
                ? scope.row.flowName
                : '一次' + scope.row.flowName
            }}：{{ scope.row.totalNum == null ? 0 : scope.row.totalNum }} /
            {{
              scope.row.flowName === 'PE'
                ? scope.row.pePackageNum
                : scope.row.oneMarkPackageNum
            }}
            /
            {{ scope.row.peProceedNum == null ? 0 : scope.row.peProceedNum }} /
            {{ scope.row.pePendingNum == null ? 0 : scope.row.pePendingNum }} /
            {{
              scope.row.flowName === 'PE'
                ? scope.row.peNum
                : scope.row.oneMarkNum
            }}
          </span>
          <br />
          <span
            v-if="
              scope.row.flowLevel == 2 ||
              scope.row.flowLevel == 4 ||
              scope.row.flowLevel == 5
            "
          >
            {{
              scope.row.flowName === 'PE'
                ? scope.row.flowName + '审核'
                : scope.row.flowLevel === 2
                ? '二次' + scope.row.flowName
                : ''
            }}{{
              scope.row.flowLevel === 2 || scope.row.flowName === 'PE'
                ? '：'
                : ''
            }}
            {{
              scope.row.flowLevel === 2 || scope.row.flowName === 'PE'
                ? scope.row.totalNum == null
                  ? 0
                  : scope.row.totalNum
                : ''
            }}
            {{
              scope.row.flowLevel === 2 || scope.row.flowName === 'PE'
                ? '/'
                : ''
            }}
            {{
              scope.row.flowLevel === 2 || scope.row.flowName === 'PE'
                ? scope.row.flowName === 'PE'
                  ? scope.row.peAuditPackageNum
                  : scope.row.twoMarkPackageNum
                : ''
            }}{{
              scope.row.flowLevel === 2 || scope.row.flowName === 'PE'
                ? ' / '
                : ''
            }}
            {{
              scope.row.flowLevel === 2 || scope.row.flowName === 'PE'
                ? scope.row.peAuditProceedNum == null
                  ? 0
                  : scope.row.peAuditProceedNum
                : ''
            }}
            {{
              scope.row.flowLevel === 2 || scope.row.flowName === 'PE'
                ? ' / '
                : ''
            }}
            {{
              scope.row.flowLevel === 2 || scope.row.flowName === 'PE'
                ? scope.row.peAuditPendingNum == null
                  ? 0
                  : scope.row.peAuditPendingNum +
                    ' / ' +
                    (scope.row.flowName === 'PE'
                      ? scope.row.peAuditNum
                      : scope.row.twoMarkNum)
                : ''
            }}
          </span>
          <span v-if="scope.row.orderFlow == 6">--</span>
        </template>
        <template slot="qc" slot-scope="scope">
          <div
            v-show="scope.row.list.length > 0"
            v-for="(item, index) in scope.row.list"
            :key="index"
          >
            <span v-if="item.qcId">
              {{ item.qcId }} : {{ item.totalProgress }} /
              {{ item.processedNum }} / {{ item.underReviewNum }} /
              {{ item.unProcessedNum }} / {{ item.waitCount }} /
              {{ item.totalCount }}
            </span>
            <span v-else>--</span>
          </div>
          <div v-if="scope.row.list.length === 0"><span>--</span></div>
        </template>
        <template slot="sortTime" slot-scope="scope">
          <span>
            {{
              scope.row.sortTime === '0'
                ? '--'
                : formatDate(Math.abs(scope.row.sortTime))
            }}
          </span>
        </template>
      </avue-crud>
    </basic-container>

    <el-drawer
      class="underwayTaskDetail"
      :visible.sync="drawer"
      :direction="direction"
      size="93%"
      title="中控系统/进行中的任务/查看详情"
      :before-close="handleClose"
    >
      <section v-if="orderFlow == 4">
        <el-row class="row-first">
          <el-col :span="4">
            <div class="bg-left grid-content bg-purple">
              语种风险值({{ riskInfoObj.dotFlowRisk.lanRisk }})
            </div>
          </el-col>
          <el-col :span="4">
            <div class="bg-left grid-content bg-purple-light">
              规模风险值({{ riskInfoObj.dotFlowRisk.scaleRisk }})
            </div>
          </el-col>
          <el-col :span="4">
            <div class="bg-left grid-content bg-purple">
              时间风险值({{ riskInfoObj.dotFlowRisk.timeRisk }})
            </div>
          </el-col>
          <el-col :span="4">
            <div class="bg-left grid-content bg-purple-light">
              资源风险值({{ riskInfoObj.dotFlowRisk.trRisk }})
            </div>
          </el-col>
          <el-col :span="4">
            <div class="bg-left bg-right grid-content bg-purple">
              客户风险值({{ riskInfoObj.dotFlowRisk.custRisk }})
            </div>
          </el-col>
          <el-col :span="4">
            <div class="bg-left grid-content bg-purple-light">
              价格风险值({{ riskInfoObj.dotFlowRisk.priceRisk }})
            </div>
          </el-col>
        </el-row>
        <el-row class="row-second">
          <el-col :span="6" class="row-total">
            {{ flowName }}环节风险总值:{{ riskInfoObj.totalRisk }}
          </el-col>
          <el-col :span="4" class="row-total">
            风险等级:{{ riskInfoObj.riskLevel }}
          </el-col>
          <el-divider />
        </el-row>
        <el-tabs
          class="row-second"
          v-model="activeName"
          @tab-click="handleClick(activeName)"
        >
          <el-tab-pane label="任务进度" name="first">
            <avue-crud :data="taskData" :option="taskOption">
              <template slot="totalNum" slot-scope="scope">
                <span>
                  {{ scope.row.totalNum == null ? '--' : scope.row.totalNum }}
                </span>
              </template>
              <template slot="pendingNum" slot-scope="scope">
                <span>
                  {{ scope.row.pendingNum }}(打回:{{
                    scope.row.returnPendingNum
                  }})
                </span>
              </template>
              <template slot="pushNum" slot-scope="scope">
                <span v-if="scope.row.taskType === 1">{{ markFirstNum }}</span>
                <span v-if="scope.row.taskType === 2">{{ markSecondNum }}</span>
                <span v-if="scope.row.taskType === 3">{{ pePackageNum }}</span>
                <span v-if="scope.row.taskType === 4">
                  {{ peAuditPackageNum }}
                </span>
              </template>
            </avue-crud>
          </el-tab-pane>
          <el-tab-pane label="订单详情" name="second">
            <avue-form
              class="form-detail"
              :option="flowName === 'PE' ? detailOption : detailOption2"
              v-model="detailObj"
              @submit="detailSubmit"
              @error="error"
            >
              <template slot-scope="scope" slot="slan">
                <el-input v-model="lan"></el-input>
              </template>
              <template slot="pmName" slot-scope="scope">
                <el-input v-model="pmNameVal"></el-input>
              </template>
            </avue-form>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="third">
            <avue-crud
              :data="logData"
              :option="logOption"
              :table-loading="logTableLoading"
              :page.sync="logPage"
              @on-load="getLogList"
              @size-change="logSizeChange"
              @current-change="logCurrentChange"
              @row-save="logSave"
            ></avue-crud>
          </el-tab-pane>
        </el-tabs>
        <el-row class="button-bottom">
          <el-col span="6" class="f-s-14">
            <div v-if="flowName === '打标'">
              <span>打标信用分门槛：{{ tagScore }}</span>
              <el-button
                style="padding-left: 10px"
                type="text"
                size="medium"
                :disabled="tagFlag"
                @click="getThreshold(2)"
              >
                修改
              </el-button>
            </div>
            <div v-if="flowLevel == 3 || flowLevel == 5">
              <span>PE信用分门槛：{{ peScore }}</span>
              <el-button
                style="padding-left: 10px"
                type="text"
                size="medium"
                :disabled="peFlag"
                @click="getThreshold(3)"
              >
                修改
              </el-button>
            </div>
            <div v-if="flowLevel == 4 || flowLevel == 5">
              <span>审核信用分门槛：{{ reviewScore }}</span>
              <el-button
                style="padding-left: 10px"
                type="text"
                size="medium"
                :disabled="reviewFlag"
                @click="getThreshold(4)"
              >
                修改
              </el-button>
            </div>
          </el-col>
          <el-col span="12" offset="8">
            <el-button
              :type="!riskInfoObj.isAddPrice ? 'primary' : 'danger'"
              @click="toggoleAdd()"
            >
              {{
                riskInfoObj.isAddPrice
                  ? toggoleAddPriceText2
                  : toggoleAddPriceText1
              }}
            </el-button>
            <el-button
              :type="!toggoleHideFlag ? 'primary' : 'danger'"
              @click="toggoleHide"
            >
              {{ toggoleHideFlag ? toggoleHideText2 : toggoleHideText1 }}
            </el-button>
            <el-button
              :type="toggoleItemFlag ? 'primary' : 'danger'"
              :disabled="!toggoleTaskFlag || numFlag"
              @click="toggoleItem()"
            >
              {{ toggoleItemFlag ? toggoleItemText1 : toggoleItemText2 }}
            </el-button>
            <el-button
              :type="toggoleTaskFlag ? 'primary' : 'danger'"
              :disabled="!toggoleItemFlag || numFlag"
              @click="toggoleTask()"
            >
              {{ toggoleTaskFlag ? toggoleTaskText1 : toggoleTaskText2 }}
            </el-button>
            <el-button type="warning" @click="spareResources()">
              备用资源
            </el-button>
          </el-col>
        </el-row>
      </section>
      <el-row v-if="activeName === 'first'" class="m-l-30">
        <el-collapse v-model="activeCollapse" accordion>
          <el-collapse-item
            title="质控数据"
            name="1"
            v-if="orderFlowName.includes('质控')"
          >
            <zkStatistics :orderId="orderId" ref="zkStatistics" />
          </el-collapse-item>
        </el-collapse>
      </el-row>
    </el-drawer>

    <!-- 隐藏项目/取消隐藏 -->
    <el-dialog
      :visible.sync="dialogHideItmeVisible"
      :title="toggoleHideText1"
      width="50%"
      @close="dialogHideItmeVisible = false"
    >
      <el-form :model="hideItemObj" :rules="hideItemRules" ref="hideItem">
        <el-form-item
          prop="taskType"
          label="请选择需要隐藏的任务类型"
          style="padding-bottom: 10px"
        >
          <el-select
            v-model="hideItemObj.taskType"
            multiple
            style="width: 240px"
            placeholder="请选择需要隐藏的任务类型"
          >
            <el-option
              v-for="item in selectable2"
              :value="item.value"
              :label="item.text"
              :key="item.text"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="remark">
          <el-input
            type="textarea"
            :rows="5"
            :show-word-limit="true"
            :maxlength="800"
            placeholder="请填写与PM达成一致的结论和沟通时间"
            v-model="hideItemObj.remark"
          ></el-input>
        </el-form-item>
        <el-form-item class="p-t-10">
          <span>
            隐藏此环节后，译员将看不到此环节的任务包，此环节的当前进度会暂停。
          </span>
        </el-form-item>
        <el-form-item>
          <div>已隐藏的任务列表</div>
          <el-table :data="hideFlowListData" style="width: 100%">
            <el-table-column prop="taskType" label="任务类型">
              <template slot-scope="scope">
                {{ transTaskType(scope.row.taskType) }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="触发时间">
              <template slot-scope="scope">
                {{
                  scope.row.updateTime != null
                    ? formatDate(scope.row.updateTime)
                    : formatDate(scope.row.createTime)
                }}
              </template>
            </el-table-column>
            <el-table-column prop="operator" label="操作人"></el-table-column>
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleCancleHideFlow(scope.row.taskType)"
                  type="text"
                  size="small"
                >
                  取消隐藏
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item>
          <el-row class="t-c p-t-10">
            <el-button
              size="medium"
              type="primary"
              @click.stop="hideItemSubmit('hideItem')"
              style="min-width: 160px"
            >
              确定
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="
                dialogHideItmeVisible = false;
                this.hideItemObj.remark = '';
              "
              style="min-width: 160px"
            >
              取消
            </el-button>
          </el-row>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 自动加价 -->
    <el-dialog
      :visible.sync="dialogAddPriceVisible"
      :title="toggoleAddPriceText1"
      width="50%"
      @close="dialogAddPriceVisible = false"
    >
      <el-form :model="addPriceObj" :rules="addPriceRules" ref="addPrice">
        <!-- todo 加价模式 -->
        <el-form-item
          prop="addType"
          label="请选择加价模式"
          style="padding-bottom: 10px"
        >
          <el-select
            v-model="addPriceObj.addType"
            style="width: 240px"
            @change="addPriceTypeChange"
            placeholder="请选择加价模式"
          >
            <el-option
              v-for="item in addPriceType"
              :value="item.value"
              :label="item.text"
              :key="item.text"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="p-b-20">
          <span v-if="addPriceObj.addType === 1">
            提示：系统将根据提供的加价总额，对待领取的任务包进行50%-100%的随机涨幅：（成本相对可控，会根据实际消托金额进行成本核算）
          </span>
          <span v-else>
            提示：系统将按照千字单价的提升金额，将待领取状态的包按照千字单价的方式涨幅(成本相对不可控)
          </span>
        </div>
        <el-form-item
          prop="priceType"
          :label="
            addPriceObj.addType === 1
              ? '请选择需要自动加价的任务类型'
              : '请选择需要加价的任务类型'
          "
        >
          <el-select
            v-model="addPriceObj.priceType"
            style="width: 240px"
            @change="addTypeEq2"
            :placeholder="
              addPriceObj.addType === 1
                ? '请选择需要加价的任务类型'
                : '请选择需要自动加价的任务类型'
            "
          >
            <el-option
              v-for="item in selectable"
              :value="item.value"
              :label="item.text"
              :key="item.text"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="addPriceObj.addType === 1"
          label="加价总额（元）"
          prop="price"
          style="padding-top: 20px"
        >
          <el-input-number
            v-model="addPriceObj.price"
            controls-position="right"
            style="width: 240px"
            :min="0"
            :step="0.01"
          ></el-input-number>
          <div>
            <span style="color: red">
              开启自动加价后，无法取消！请PM核对项目成本后，谨慎操作！
            </span>
          </div>
        </el-form-item>
        <el-form-item v-else prop="afterPrice" style="padding-top: 14px">
          <div>
            <span style="color: red">
              开启自动加价后，无法取消！请PM核对项目成本后，谨慎操作！
            </span>
          </div>
          <el-row :span="24" style="padding: 10px">
            <span>原始单价：</span>
            <el-input
              disabled
              v-model="addPriceObj.beforePrice"
              type="number"
              controls-position="right"
              style="width: 300px"
              :min="0"
              :max="50"
              :step="1"
              oninput="if(value>50){value=50}"
              @input="(e) => (addPriceObj.beforePrice = integerFn(e))"
            >
              <template slot="prepend">
                {{
                  addPriceObj.priceType
                    ? selectable.find(
                        (it) => it.value === addPriceObj.priceType,
                      ).text
                    : ''
                }}
              </template>
              <template slot="append">元/千字</template>
            </el-input>
          </el-row>
          <el-row :span="24" style="padding: 10px">
            <span style="color: red; padding-left: 13px">调整后：</span>
            <el-input
              v-model="addPriceObj.afterPrice"
              type="number"
              controls-position="right"
              style="width: 300px"
              :min="0"
              :max="50"
              :step="0.01"
              oninput="if(value>50){value=50}"
              @input="formatNum(addPriceObj.afterPrice, 'afterPrice')"
            >
              <template slot="prepend">
                {{
                  addPriceObj.priceType
                    ? selectable.find(
                        (it) => it.value === addPriceObj.priceType,
                      ).text
                    : ''
                }}
              </template>
              <template slot="append">元/千字</template>
            </el-input>
          </el-row>
        </el-form-item>
        <el-form-item class="p-t-10">
          <div>加价历史列表</div>
          <el-table :data="orderAddListData" style="width: 100%">
            <el-table-column prop="taskType" label="任务类型">
              <template slot-scope="scope">
                {{ transTaskType(scope.row.taskType) }}
              </template>
            </el-table-column>
            <el-table-column prop="addType" label="加价类型">
              <template slot-scope="scope">
                {{ addType(scope.row.addType) }}
              </template>
            </el-table-column>
            <el-table-column prop="lastAmount" label="原始金额">
              <template slot-scope="scope">
                {{ scope.row.lastAmount
                }}{{ scope.row.addType === 1 ? '元' : '元 / 千字' }}
              </template>
            </el-table-column>
            <el-table-column prop="maxAmount" label="调整后金额">
              <template slot-scope="scope">
                {{ scope.row.maxAmount
                }}{{ scope.row.addType === 1 ? '元' : '元 / 千字' }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="时间">
              <template slot-scope="scope">
                {{
                  scope.row.updateTime != null
                    ? formatDate(scope.row.updateTime)
                    : formatDate(scope.row.createTime)
                }}
              </template>
            </el-table-column>
            <el-table-column prop="operator" label="操作人"></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item>
          <el-row class="t-c p-t-10">
            <el-button
              size="medium"
              type="primary"
              @click.stop="addPriceSubmit('addPrice')"
              style="min-width: 160px"
            >
              确定
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="
                dialogAddPriceVisible = false;
                addPriceObj = { addType: 1, price: 0, afterPrice: 0 };
              "
              style="min-width: 160px"
            >
              取消
            </el-button>
          </el-row>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 备用资源 -->
    <el-dialog
      :visible.sync="dialogSpareResourcesVisible"
      title="备用资源"
      width="50%"
      @close="dialogSpareResourcesVisible = false"
    >
      <el-form
        :model="spareResourcesObj"
        :rules="spareResourcesRules"
        ref="spareResources"
      >
        <el-form-item prop="taskType" label="请选择增加备用资源的任务类型">
          <el-select
            style="padding-left: 20px; width: 350px"
            v-model="spareResourcesObj.taskType"
            placeholder="请选择需要增加备用资源的任务类型"
            @change="spareResourcesChange"
          >
            <el-option
              v-for="item in selectable"
              :value="item.value"
              :label="item.text"
              :key="item.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="本项目备用资源" prop="trIds" class="p-tb-20">
          <div class="edit" id="app" style="height: 350px">
            <div id="leftBox">
              <textarea wrap="off" cols="2" id="leftNum" disabled></textarea>
            </div>
            <textarea
              rows="9"
              cols="50"
              placeholder="请输入译员ID,换行输入,每行一个译员：
  举例如下：
  WE000000000000000001TR
  WE000000000000000002TR
          "
              v-model="spareResourcesObj.trIds"
              @keyup="keyup"
              @input="handleTextareaInput"
              onscroll="document.getElementById('leftNum').scrollTop = this.scrollTop;"
              id="edit-content"
            ></textarea>
          </div>
          <el-row>
            <el-col :span="13">
              <span class="red">输入人员ID必须小于500个，超过无法添加！</span>
            </el-col>
            <el-col :span="3" offset="9">
              <span class="red">
                {{
                  spareResourcesObj.trIds.split('\n').filter((it) => it !== '')
                    .length
                }}
                / 500
              </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7">
              <el-button type="text" size="medium" @click="openBackup">
                从公共备用资源库中选择
              </el-button>
            </el-col>
            <el-col :span="4">
              <span class="red">已选{{ selectionList.length }}人</span>
            </el-col>
          </el-row>
          <el-row><span class="grey-font">说明：</span></el-row>
          <el-row>
            <span class="grey-font">
              1）如需要增加的备用资源过多时，应该尝试降低本项目的信用分门槛;
            </span>
          </el-row>
          <el-row>
            <span class="grey-font">
              2）被质控禁用的人员，将不能加入本项目备用资源;
            </span>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-col class="t-c p-t-10">
            <el-button
              size="medium"
              type="primary"
              @click.stop="spareResourcesSubmit('spareResources')"
              style="min-width: 160px"
            >
              确定
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="
                dialogSpareResourcesVisible = false;
                spareResourcesObj = { taskType: '', trIds: '' };
              "
              style="min-width: 160px"
            >
              取消
            </el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 备用资源列表 -->
    <el-dialog
      id="backupListDialog"
      :visible.sync="resourcesListVisible"
      title="备用资源库"
      :show-close="false"
      width="80%"
      center="true"
    >
      <div slot="title" class="dialog-title">
        <el-row>
          <el-col span="23"><span class="title-text">备用资源库</span></el-col>
          <el-col span="1" style="cursor: pointer">
            <i class="el-icon-close" @click="closeBackup"></i>
          </el-col>
        </el-row>
      </div>
      <avue-crud
        id="backupList"
        ref="crud2"
        :data="tableData2"
        :table-loading="tableLoading2"
        :option="tableOption2"
        v-model="form2"
        @on-load="getList2"
        :search.sync="search2"
        @search-change="searchChange2"
        @search-reset="searchRest"
        @sort-change="sortChange2"
        @selection-change="selectionChange"
        @refresh-change="refreshChange2"
        @size-change="sizeChange2"
        @current-change="currentChange2"
      >
        <template slot-scope="{ disabled, size }" slot="nickNameSearch">
          <el-form-item label="">
            <el-input
              placeholder="请输入译员昵称/姓名/手机号码"
              :disabled="disabled"
              :size="size"
              v-model="search2.nickName"
            ></el-input>
          </el-form-item>
        </template>
        <template slot="tip">
          <el-tag type="danger" size="mini">推送上限人数：500</el-tag>
        </template>
        <div slot="footer" class="dialog-footer">
          <span>备用资源库如需要重新更新，请前往资源列表进行更新</span>
          <div style="text-align: center" class="grey-font">
            <el-button type="primary" @click="resourcesListSubmit">
              确 定
            </el-button>
            <el-button
              @click="
                resourcesListVisible = false;
                toggleSelection();
              "
            >
              取 消
            </el-button>
          </div>
        </div>
      </avue-crud>
    </el-dialog>
  </div>
</template>

<script>
import zkStatistics from '../dot/order/taskTemplate/qc-statistics';
import { industry } from '@/api/qc/manage';
import {
  addLog,
  addTaskMaxAmount,
  orderPeConfig,
  addTaskReserveTr,
  bottomFlow,
  cancelHideFlow,
  cancelSort,
  capacityStatistics,
  getScore,
  getScoureStatus,
  hideFlow,
  hideFlowList,
  languageEmun,
  listByRoleCode,
  logList,
  projectStausEmun,
  queryPushTrNum,
  riskInfoByFlowId,
  taskInfoByFlowId,
  taskList,
  taskNumList,
  topFlow,
  updateRisk,
  updateScore,
  proceedQcMap,
} from '@/api/centralControl/ongoingTask';
import { statistics } from '@/api/dot/flow';
import {
  backupList,
  checkAddBackUpTr,
  qcDisableTrIds,
} from '@/api/resource/backup';
import { tableOption } from '@/const/crud/centralControl/ongoingTask';
import { tableOption2 } from '@/const/crud/resource/backup';
import { mapGetters, mapState } from 'vuex';
import { formatDate } from '@/util/date';
import { integerFn, jsonFlatten, trIdReg, toLine } from '@/util/util';
import { $sysLan } from '@/config/status';
import { getTaskReserveTr, orderAddList } from '@/api/centralControl/examine';

export default {
  name: 'log',
  components: { zkStatistics },
  data() {
    var checkAfterPrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('调整后单价不能为空'));
      }
      setTimeout(() => {
        if (value <= this.addPriceObj.beforePrice) {
          callback(new Error('调整后单价必须大于原始单价'));
        } else {
          callback();
        }
      }, 200);
    };
    return {
      selectFlag: false, // checkedNum用
      selectionList: [],
      backupOrder: {},
      orderPeConfigObj: {}, // 千字单价PE和PE审核
      qcDisableTrIds: [],
      num: '',
      submitIdList: [],
      idList: [],
      thresholdFlag: false,
      tagFlag: false,
      peFlag: false,
      reviewFlag: false,
      threshold: 0,
      peScore: 0, // PE信用分
      reviewScore: 0, // 审核信用分
      tagScore: 0, // 打标信用分
      pendPeNum: 0,
      pendAuditNum: 0,
      activeNum: 0,
      activeTwoNum: 0,
      tempData: [],
      activeCollapse: '1',
      orderId: '',
      orderAddListData: [],
      hideFlowListData: [],
      search: {
        text: '',
        pmId: '',
        sortType: null,
        riskLevel: null,
        autoType: null,
        language: null,
        pending: false,
        fieldCode: '',
        qcId: '',
      },
      industryListArr: [],
      search2: {},
      hideItemRules: {
        taskType: [{ required: true, message: '  ', trigger: 'change' }],
        remark: [
          {
            required: true,
            message: '请填写与PM达成一致的结论和沟通时间',
            trigger: 'blur',
          },
        ],
      },
      addPriceRules: {
        addType: [
          { required: true, message: '请选择加价模式', trigger: 'change' },
        ],
        priceType: [
          { required: true, message: '请选择加价类型', trigger: 'change' },
        ],
        price: [
          {
            required: true,
            message: '请填写与PM达成一致的结论和沟通时间',
            trigger: 'blur',
          },
        ],
        afterPrice: [{ validator: checkAfterPrice, trigger: 'blur' }],
      },
      spareResourcesRules: {
        taskType: [
          { required: true, message: '请选择备用资源类型', trigger: 'change' },
        ],
        trIds: [
          { required: true, message: '请填写备用译员ID', trigger: 'blur' },
        ],
      },
      hideItemObj: {
        taskType: 0,
        remark: '',
      },
      addPriceObj: {
        addType: 1,
        priceType: null,
        price: 0,
        beforePrice: 0,
        afterPrice: 0,
      },
      spareResourcesObj: {
        taskType: null,
        trIds: '',
        backup: false,
      },
      flowId: '',
      flowName: '',
      orderFlowName: '',
      flowLevel: null,
      orderFlow: null,
      refreshText: '刷新中...',
      refreshLoading: false,
      dialogHideItmeVisible: false,
      dialogAddPriceVisible: false,
      dialogSpareResourcesVisible: false,
      resourcesListVisible: false,
      numFlag: false,
      markFirstNum: '',
      markSecondNum: '',
      pePackageNum: '',
      peAuditPackageNum: '',
      toggoleAddPriceFlag: true,
      toggoleHideFlag: false,
      toggoleItemFlag: true,
      toggoleTaskFlag: true,
      toggoleAddPriceText1: '自动加价',
      toggoleAddPriceText2: '已开启自动加价',
      toggoleHideText1: '隐藏项目',
      toggoleHideText2: '已开启隐藏项目',
      toggoleItemText1: '置顶项目',
      toggoleItemText2: '取消置顶',
      toggoleTaskText1: '置底任务',
      toggoleTaskText2: '取消置底',
      drawer: false,
      direction: 'rtl',
      activeName: 'first',
      taskText1: '点击只看高风险任务',
      taskText2: '点击只看低风险任务',
      pmOptions: [],
      itemOptions: [
        {
          value: 1,
          label: '置顶项目',
        },
        {
          value: 2,
          label: '置底项目',
        },
      ],
      riskLevelOptions: [
        {
          value: 1,
          label: '低风险任务',
        },
        {
          value: 2,
          label: '预警任务',
        },
      ],
      autoTypeOptions: [
        {
          value: 2,
          label: '自动化',
        },
        {
          value: 1,
          label: '非自动化',
        },
      ],
      languageOptions: [],
      form: {},
      form2: {},
      orderObj: {},
      credibility: '',
      tableData: [],
      tableData2: [],
      taskData: [],
      logData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 50, // 每页显示多少条
      },
      page2: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 1000, // 每页显示多少条
      },
      logPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      tableLoading: false,
      tableLoading2: false,
      logTableLoading: false,
      importObj: {},
      exportObj: {},
      detailObj: {},
      riskInfoObj: {
        totalRisk: 0,
        riskLevel: 0,
        dotFlowRisk: {
          lanRisk: 0,
          scaleRisk: 0,
          timeRisk: 0,
          trRisk: 0,
          custRisk: 0,
          priceRisk: 0,
        },
        isAddPrice: false,
        flowLevel: 0,
        status: -5,
      },
      tableOption: tableOption,
      tableOption2: tableOption2,
      taskOption: {
        page: false,
        addBtn: false,
        menu: false,
        align: 'center',
        menuAlign: 'center',
        column: [
          {
            label: '任务类型',
            prop: 'taskType',
            type: 'select',
            dicUrl: `/dotadmin/dotRisk/taskTypeEmun`,
            // dicData: []
          },
          {
            label: '总句数',
            prop: 'totalNum',
          },
          {
            label: '已完成句数',
            prop: 'finishNum',
          },
          {
            label: '进行中包数',
            prop: 'proceedNum',
          },
          {
            label: '待领取包数',
            prop: 'pendingNum',
            slot: true,
          },
          {
            label: '已推送人数',
            prop: 'pushNum',
            slot: true,
          },
        ],
      },
      logOption: {
        addBtn: true,
        menu: false,
        align: 'center',
        menuAlign: 'center',
        column: [
          {
            label: '时间',
            prop: 'createTime',
            minWidth: 120,
            // type: "date",
            addDisplay: false,
            // format: "yyyy-MM-dd HH:mm:ss",
            // valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
          {
            label: '事项',
            minWidth: 550,
            row: true,
            span: 24,
            addDisplay: false,
            prop: 'content',
          },
          {
            label: '备注',
            row: true,
            span: 24,
            type: 'textarea',
            maxlength: 200,
            rules: {
              required: true,
              message: '请输入事项',
              trigger: 'blur',
            },
            showWordLimit: true,
            prop: 'remark',
          },
          {
            label: '操作人',
            minWidth: 80,
            addDisplay: false,
            prop: 'operationName',
          },
        ],
      },
      detailOption: {
        emptyBtn: false,
        submitBtn: false,
        detail: true,
        group: [],
      },
      detailOption2: {
        emptyBtn: false,
        submitBtn: false,
        detail: true,
        group: [
          {
            label: '',
            column: [
              {
                label: '轻任务订单号',
                labelPosition: 'left',
                className: 'formClassName2',
                disabled: true,
                labelWidth: 130,
                width: 310,
                prop: 'orderId',
                searchLabelWidth: 130,
                span: 12,
              },
              {
                label: '来源ID',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                width: 310,
                prop: 'sourceId',
                span: 12,
              },
              {
                label: '任务总字数',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                prop: 'totalWords',
              },
              {
                label: '客户名称',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                prop: 'custName',
              },
              {
                label: '发起人',
                labelPosition: 'left',
                className: 'formClassName2',
                disabled: true,
                prop: 'pmName',
                labelWidth: 130,
              },
              {
                label: '语种',
                labelPosition: 'left',
                className: 'formClassName2',
                disabled: true,
                labelWidth: 130,
                prop: 'slan',
              },
              {
                label: '任务创建时间',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                prop: 'createTime',
              },
              {
                label: '任务截止时间',
                labelPosition: 'left',
                className: 'formClassName2',
                formslot: true,
                labelslot: true,
                disabled: true,
                labelWidth: 130,
                prop: 'limitTime',
              },
            ],
          },
          {
            label: '打标设置',
            prop: 'dbxx',
            column: [
              {
                label: '打标价格',
                labelPosition: 'left',
                className: 'formClassName',
                disabled: true,
                labelWidth: 130,
                formslot: true,
                labelslot: true,
                append: '元/千字',
                prop: 'markingPrice',
              },
              {
                label: '打标预计处理时间',
                labelPosition: 'left',
                className: 'formClassName3',
                disabled: true,
                prop: 'markDealTime',
                formslot: true,
                labelslot: true,
                append: '秒/字',
                labelWidth: 130,
              },
              {
                label: '打标限制提交时间',
                labelPosition: 'left',
                className: 'formClassName3',
                formslot: true,
                labelslot: true,
                disabled: true,
                labelWidth: 130,
                append: '小时',
                prop: 'markLimitTime',
              },
              {
                label: '打标比例',
                labelPosition: 'left',
                className: 'formClassName3',
                formslot: true,
                labelslot: true,
                disabled: true,
                labelWidth: 130,
                append: '%',
                prop: 'markingRatio',
              },
            ],
          },
        ],
      },
      staParams: null,
      processQcList: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curPath = to.path;
      vm.oldPath = from.path;
    });
  },
  computed: {
    ...mapGetters(['permissions', 'userInfo']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),

    lan() {
      return (
        $sysLan.get(this.detailObj.slan) +
        '--' +
        $sysLan.get(this.detailObj.tlan)
      );
    },
    selectable() {
      // let arr = [{text:'一次打标',value:1}, {text:'PE',value:3}, {text:'PE审核',value: 4}];
      let arr = [{ text: '一次打标', value: 1 }];
      let tempArr = arr.filter((it) => it.text.indexOf(this.flowName) > -1);
      if (this.riskInfoObj.flowLevel === 3 && this.flowName === 'PE') {
        tempArr.push({ text: 'PE', value: 3 });
      }
      if (this.riskInfoObj.flowLevel === 4 && this.flowName === 'PE') {
        tempArr.push({ text: 'PE审核', value: 4 });
      }
      if (this.riskInfoObj.flowLevel === 5) {
        tempArr.push({ text: 'PE', value: 3 }, { text: 'PE审核', value: 4 });
      }
      if (this.riskInfoObj.flowLevel === 2 && this.flowName === '打标') {
        tempArr.push({ text: '二次打标', value: 2 });
      }
      return tempArr;
    },
    addPriceType() {
      return [
        { text: '总价随机上涨', value: 1, disabled: false },
        { text: '千字单价上涨', value: 2, disabled: false },
      ];
    },
    selectable2() {
      // let arr = [{text:'一次打标',value:1}, {text:'PE',value:3}, {text:'PE审核',value: 4}];
      let arr = [{ text: '一次打标', value: 1 }];
      let tempArr = arr.filter((it) => it.text.indexOf(this.flowName) > -1);
      if (this.riskInfoObj.flowLevel === 3 && this.flowName === 'PE') {
        tempArr.push({ text: 'PE', value: 3 });
      }
      if (this.riskInfoObj.flowLevel === 4 && this.flowName === 'PE') {
        tempArr.push({ text: 'PE审核', value: 4 });
      }
      if (this.riskInfoObj.flowLevel === 5) {
        tempArr.push({ text: 'PE', value: 3 }, { text: 'PE审核', value: 4 });
      }
      if (this.riskInfoObj.flowLevel === 2 && this.flowName === '打标') {
        tempArr.push({ text: '二次打标', value: 2 });
      }
      return tempArr;
    },
    pmNameVal() {
      return this.pmOptions.find((it) => it.username === this.detailObj.pmName)
        ? this.pmOptions.find((it) => it.username === this.detailObj.pmName)
            .label
        : '';
    },
  },
  mounted() {
    this.getIndustryList();
    this.getProcessQcList();
    this.handleTextareaInput({
      target: { value: this.spareResourcesObj.trIds },
    });
    this.refreshText = this.getNowFormatDate() + ' 已刷新';

    languageEmun().then((res) => {
      this.languageOptions = res.data.data;
    });

    capacityStatistics().then((res) => {
      this.pendPeNum = res.data.data.pendPeNum;
      this.pendAuditNum = res.data.data.pendAuditNum;
      this.activeNum = res.data.data.activeNum;
      this.activeTwoNum = res.data.data.activeTwoNum;
    });

    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      scene_name: '进行中任务',
    };
    this.statistics();
  },
  methods: {
    statistics() {
      statistics(
        Object.assign(
          {
            event_type: 'view',
            ref_url: this.oldPath,
          },
          this.staParams,
        ),
      );
    },

    getProcessQcList() {
      proceedQcMap().then((res) => {
        const obj = res.data?.data;
        this.processQcList = Object.entries(obj).map(([key, value]) => ({
          label: value,
          value: key,
        }));
        console.log(this.processQcList);
      });
    },

    // 获取领域列表
    getIndustryList() {
      industry({}).then((res) => {
        this.industryListArr = res.data?.data;
      });
    },

    closeBackup() {
      this.resourcesListVisible = false;
      this.toggleSelection();
    },
    formatNum(val, key) {
      let temp = val.toString();
      temp = temp.replace(/。/g, '.');
      temp = temp.replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
      temp = temp.replace(/^\./g, ''); //验证第一个字符是数字
      temp = temp.replace(/\.{2,}/g, ''); //只保留第一个, 清除多余的
      temp = temp.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
      this.addPriceObj[key] = temp;
    },
    addTypeEq2(val) {
      if (val === 3) {
        this.addPriceObj.beforePrice = this.orderPeConfigObj.pePrice;
      } else {
        this.addPriceObj.beforePrice = this.orderPeConfigObj.peAuditPrice;
      }
    },
    addPriceTypeChange(val) {
      if (val === 2) {
        let map = this.orderAddListData
          .filter((it) => it.addType === 2)
          .map((it) => it.taskType);
        this.addPriceType.find((it) => it.value === 2).disabled =
          map.includes(3) && map.includes(4);
        if (this.selectable.find((it) => it.value === 3)) {
          this.selectable.find((it) => it.value === 3).disabled =
            map.includes(3) && this.addPriceObj.addType === 2;
        }
        if (this.selectable.find((it) => it.value === 4)) {
          this.selectable.find((it) => it.value === 4).disabled =
            map.includes(4) && this.addPriceObj.addType === 2;
        }
        orderPeConfig({ orderId: this.detailObj.orderId })
          .then((res) => {
            if (res.data.data) {
              this.orderPeConfigObj = res.data.data;
              if (this.addPriceObj.priceType == 3) {
                this.addPriceObj.beforePrice = this.orderPeConfigObj.pePrice;
              } else {
                this.addPriceObj.beforePrice =
                  this.orderPeConfigObj.peAuditPrice;
              }
            } else {
              this.$message.error('未知错误,请联系管理员');
            }
          })
          .catch((err) => {});
      } else {
        this.selectable.forEach((it) => (it.disabled = false));
      }
    },
    openBackup() {
      if (this.spareResourcesObj.taskType) {
        this.resourcesListVisible = true;
        this.page2.currentPage = 1;
        this.getList2(this.page2);
      } else {
        this.$message.info('请先选择任务类型');
      }
    },
    intersection(arr1, arr2) {
      // 去除重复元素
      let a = new Set(arr1);
      let b = new Set(arr2);
      return [...a].filter((v) => [...b].includes(v));
    },
    keyup(e) {
      // console.log(e.target.value);
      // console.log(this.spareResourcesObj.trIds.split('\n').length);
      if (e.target.value.split('\n').length >= 500) {
        this.spareResourcesObj.trIds = e.target.value
          .split('\n')
          .slice(0, 500)
          .join('\n');
      }
    },
    handleTextareaInput(e) {
      let str = e.target.value;
      str = str.replace(/\r/gi, '');
      str = str.split('\n').filter((it) => it !== '');
      let n = str.length;
      let lineObj = document.getElementById('leftNum');
      for (let i = 1; i <= n; i++) {
        if (document.all) {
          this.num += i + '\r\n'; //判断浏览器是否是IE
        } else {
          this.num += i + '\n';
        }
      }
      if (lineObj) {
        lineObj.value = this.num;
      }
      this.num = '';
    },
    toggleSelection(val) {
      // this.idList = [];
      if (this.$refs.crud2) {
        this.$refs.crud2.toggleSelection(val);
      }
    },
    selectionChange(list) {
      let length = this.spareResourcesObj.trIds
        .split('\n')
        .filter((it) => it.trim() !== '').length;
      let tempTextAreaIds = this.spareResourcesObj.trIds
        .split('\n')
        .filter((it) => it.trim() !== '');
      let tempCheckedIds = list.map((it) => it.id);
      let union = tempTextAreaIds.concat(
        tempCheckedIds.filter(function (val) {
          return !(tempTextAreaIds.indexOf(val) > -1);
        }),
      );
      let intersection = this.intersection(tempCheckedIds, tempCheckedIds);
      let filter = list.filter((it) => intersection.includes(it.id));
      let tempFilter = filter.slice(500);
      // console.log(union)
      if (union.length <= 500) {
        // 判断表格和textarea是否超过50行
        this.idList = [...new Set(list.map((it) => it.id))];
      } else if (union.length > 500 && filter.length > 0) {
        if (filter.length > 0) {
          if (tempFilter.length === 1) {
            this.$message.error('最多只能选择500条数据');
          }
          tempFilter.forEach((it) => {
            this.$refs.crud2.toggleRowSelection(it, false);
          });
        }
      } else {
        let tempArr = list.slice(500 - length);
        if (tempArr.length > 0) {
          if (tempArr.length === 1) {
            this.$message.error('最多只能选择500条数据');
          }
          tempArr.forEach((it) => {
            this.$refs.crud2.toggleRowSelection(it, false);
          });
        }
      }
      this.selectionList = list.slice(0, 500);
      let textareaLength = this.spareResourcesObj.trIds
        .split('\n')
        .filter((it) => it !== '').length;
      if (textareaLength === this.selectionList.length) {
        this.selectFlag = true;
      }
    },
    unique(arr) {
      return Array.from(new Set(arr));
    },
    resourcesListSubmit() {
      this.resourcesListVisible = false;
      let diffArr;
      if (this.idList.length > this.submitIdList.length) {
        diffArr = this.idList
          .concat(this.submitIdList)
          .filter((item) => !this.submitIdList.includes(item));
      } else {
        diffArr = this.submitIdList
          .concat(this.idList)
          .filter((item) => !this.idList.includes(item));
      }
      diffArr.forEach((it) => {
        // 删除id
        if (this.spareResourcesObj.trIds.indexOf(it) > -1) {
          this.spareResourcesObj.trIds = this.spareResourcesObj.trIds.replace(
            it,
            '',
          );
        }
      });
      let string =
        this.spareResourcesObj.trIds.substr(
          this.spareResourcesObj.trIds.length - 2,
        ) === '\n'
          ? ''
          : this.spareResourcesObj.trIds.length === 0
          ? ''
          : '\n';
      this.spareResourcesObj.trIds =
        this.spareResourcesObj.trIds.split(',') +
        string +
        this.idList.join('\n');
      this.spareResourcesObj.trIds = this.unique(
        this.spareResourcesObj.trIds.split('\n'),
      ).join('\n');
      this.spareResourcesObj.trIds = this.spareResourcesObj.trIds.replace(
        /\n+/g,
        '\n',
      );
      if (this.spareResourcesObj.trIds.startsWith('\n')) {
        this.spareResourcesObj.trIds = this.spareResourcesObj.trIds.substr(1);
      }
      this.submitIdList = JSON.parse(JSON.stringify(this.idList));
      this.handleTextareaInput({
        target: { value: this.spareResourcesObj.trIds },
      });
    },
    getList2(page, params) {
      this.tableLoading2 = true;
      backupList(
        Object.assign(
          {
            pageNo: page.currentPage,
            pageSize: 10000,
            pointAutoUpdate: null,
            isDisabled: null,
          },
          params,
          this.backupOrder,
        ),
      )
        .then((response) => {
          this.tableData2 = response.data.data.records;
          let arr = this.spareResourcesObj.trIds
            .split('\n')
            .filter((it) => it.trim() !== '');
          let inersectionArr = this.intersection(
            this.tableData2.map((it) => it.id),
            arr,
          );
          let filter = this.tableData2.filter((it) =>
            inersectionArr.includes(it.id),
          );
          let filterIds = filter.map((it) => it.id); // 已选择的id
          // this.$message.success(this.idList)
          let diffArr = filterIds
            .concat(this.idList)
            .filter((item) => !this.idList.includes(item));
          let diffArr2 = this.tableData2.filter((it) =>
            diffArr.includes(it.id),
          );
          // console.log(this.selectionList)
          if (diffArr2.length > 0) {
            this.toggleSelection(diffArr2);
            // diffArr2.forEach(it=>{
            //   this.$refs.crud2.toggleRowSelection(it, true);
            // })
          }
          this.page2.total = response.data.data.total;
          this.tableLoading2 = false;
        })
        .then(() => {
          if (this.spareResourcesObj.taskType === 4) {
            qcDisableTrIds({ orderId: this.orderId, taskType: 4 }).then(
              (res) => {
                let trIds = res.data.data;
                for (let i = 0; i < this.tableData2.length; i++) {
                  this.$set(
                    this.tableData2[i],
                    'isQcDisabled',
                    trIds.includes(this.tableData2[i].id),
                  );
                }
              },
            );
          }
        });
    },
    // 译员清空有问题
    searchRest(form) {
      this.search.pending = false;
      this.search2.id = '';
      this.tableData = JSON.parse(this.tempData);
    },
    searchChange2(form, done) {
      // this.tempForm = form;
      this.page2.currentPage = 1; //避免翻页了再搜索为空的情况，明明应该有数据
      this.getList2(this.page2, form);
      done();
    },
    sizeChange2(pageSize) {
      this.page2.pageSize = pageSize;
    },
    currentChange2(current) {
      this.page2.currentPage = current;
    },
    refreshChange2() {
      this.getList2(this.page2);
    },
    integerFn(val) {
      return integerFn(val);
    },

    getThreshold(type) {
      this.$prompt(
        '修改' +
          (type == 2 ? '打标' : type == 3 ? 'PE' : '审核') +
          '信用分门槛',
        '',
        {
          confirmButtonText: '确定',
          closeOnClickModal: false,
          cancelButtonText: '取消',
          inputPlaceholder: '请输入0-100以内的数(小数点保留2位)',
          inputType: 'number',
          inputValue:
            type == 2
              ? this.tagScore
              : type == 3
              ? this.peScore
              : this.reviewScore,
          // inputPattern: /^([1-9]\d*|[0]{1,1})$/,
          inputPattern: /^(([1-9]?\d(\.\d{1,2})?)|100|100.0|100.00)$/,
          inputErrorMessage: '请输入0-100以内的数(小数点保留2位)',
        },
      )
        .then(({ value }) => {
          updateScore({
            staffId: this.userInfo.staffId,
            orderId: this.orderId,
            taskType: type,
            score: parseFloat(value),
          }).then((res) => {
            let code = res.data.data;
            if (code === 1) {
              if (type == 2) {
                this.tagScore = parseFloat(value);
              } else if (type == 3) {
                this.peScore = parseFloat(value);
              } else if (type == 4) {
                this.reviewScore = parseFloat(value);
              }
              getScoureStatus({
                orderId: this.orderId,
                taskType: type,
              }).then((res) => {
                let code = res.data.data;
                if (type == 2) {
                  this.tagFlag = code < 0;
                } else if (type == 3) {
                  this.peFlag = code < 0;
                } else if (type == 4) {
                  this.reviewFlag = code < 0;
                }
              });
              this.$message.success('修改成功');
            } else if (code === -2) {
              this.$message.error('修改分数与原分数一致');
            } else if (code === -3) {
              this.$message.error('半小时只能修改一次');
            } else if (code === -4 || code === -4) {
              this.$message.error('不允许修改');
            } else {
              this.$message.error('修改失败');
            }
          });
          statistics(
            Object.assign(
              {
                event_name: '修改信用分门槛',
                event_type: 'click',
                class_name: 'updateScore',
                class_url: '/dotadmin/dotRisk/updateScore',
                event_params:
                  "{staffId: this.userInfo.staffId, flowId: this.flowId, remark: ''}",
              },
              this.staParams,
            ),
          );
        })
        .catch(() => {});
    },
    pendingChange(val) {
      if (val) {
        this.tableData = JSON.parse(this.tempData).filter(
          (it) => !(it.pePendingNum === 0 && it.peAuditPendingNum === 0),
        );
      } else {
        this.tableData = JSON.parse(this.tempData);
      }
    },
    handleSelect2() {
      this.selectable2.forEach((it) => {
        it.disabled = !!this.hideFlowListData.find(
          (i) => i.taskType === it.value,
        );
      });
    },
    // 取消隐藏流程
    handleCancleHideFlow(taskType) {
      cancelHideFlow({
        userId: this.userInfo.staffId,
        flowId: this.flowId,
        remark: '',
        taskType: taskType,
      }).then((res) => {
        let data = res.data.data;
        if (data > 0) {
          this.$message.success('取消隐藏项目成功！');
          this.dialogHideItmeVisible = !this.dialogHideItmeVisible;
          this.hideItemObj.remark = '';
          hideFlowList({ flowId: this.flowId }).then((res) => {
            this.hideFlowListData = res.data.data;
            this.handleSelect2();
            this.toggoleHideFlag =
              this.hideFlowListData && this.hideFlowListData.length > 0;
          });
        } else if (data === -1) {
          this.$message.error('参数异常,隐藏失败');
        } else if (data === -2) {
          this.$message.error('未隐藏，不能取消隐藏');
        } else if (data === -3) {
          this.$message.error('流程状态已改变，不能操作');
        } else {
          this.$message.error('系统异常,隐藏失败');
        }
      });
      statistics(
        Object.assign(
          {
            event_name: '取消隐藏',
            event_type: 'click',
            class_name: 'cancelHideFlow',
            class_url: '/dotadmin/dotRisk/cancelHideFlowe',
            event_params:
              "{userId: this.userInfo.staffId, flowId: this.flowId, remark: '', taskType: taskType}",
          },
          this.staParams,
        ),
      );
    },
    // 处理trIds
    dealTrIds(text) {
      text = text.replace(/[\s,]/g, ' ').trim();
      text = text.replace(/[' ']+/g, ',');
      return text;
      // 以下是返回数组
      // if (text.length === 0) {
      //   return [];
      // }
      // return text.split(/[\s,]/);
    },
    isRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        hash[arr[i]] = true;
      }
      return false;
    },
    dealTrIdsAsArr(text) {
      text = text.replace(/[\s,]/g, ' ').trim();
      text = text.replace(/[' ']+/g, ',');
      // 以下是返回数组
      if (text.length === 0) {
        return [];
      }
      return text.split(/[\s,]/);
    },
    // 备用资源下拉框change事件
    spareResourcesChange(val) {
      this.idList = [];
      this.selectionList = [];
      this.submitIdList = [];
      this.toggleSelection();
      this.selectFlag = false;
      getTaskReserveTr({ orderId: this.orderId, taskType: val }).then((res) => {
        if (res.data.data && res.data.data !== '') {
          this.spareResourcesObj.trIds = res.data.data.trId.replace(/,/g, '\n');
        } else {
          this.spareResourcesObj.trIds = '';
        }
        this.$set(this.tableOption2.column[8], 'hide', val !== 4);
        this.handleTextareaInput({
          target: { value: this.spareResourcesObj.trIds },
        });
      });
    },
    // 转行taskType
    transTaskType(val) {
      if (val === 1) {
        return '一次打标';
      } else if (val === 2) {
        return '二次打标';
      } else if (val === 3) {
        return 'PE';
      } else if (val === 4) {
        return 'PE审核';
      }
    },
    addType(val) {
      if (val === 1) {
        return '总价随机上涨';
      } else {
        return '千字单价上涨';
      }
    },
    resetForm(formName) {
      this.hideItemObj.remark = '';
    },
    spareResourcesSubmit(formRef) {
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          let tempTrIds = this.spareResourcesObj.trIds;
          let asArr = this.dealTrIdsAsArr(tempTrIds);
          if (asArr.length > 500) {
            this.$message.error('输入人员ID必须小于50个，超过无法添加！');
            return;
          }
          let resultArr = asArr.filter((it) => it.search(trIdReg) < 0);
          let resultArr2 = asArr.filter((it) => it.length > 32);
          if (resultArr2.length > 0) {
            this.$message.error(
              '如下译员ID长度超过32个字符:  ' + '\n\r' + resultArr2,
            );
            return;
          }
          if (resultArr.length === 0) {
            let trIds = this.dealTrIds(tempTrIds);
            if (!this.isRepeat(trIds.split(','))) {
              // 确定新增备用资源之前，先判断是否可用
              checkAddBackUpTr({
                orderId: this.orderId,
                trIds: trIds,
                type: this.spareResourcesObj.taskType,
              }).then((res) => {
                let arr = res.data.data;
                if (arr.length > 0) {
                  let idListTemp = this.idList
                    .concat(arr)
                    .filter((it) => !arr.includes(it));
                  let diffSelect = this.selectionList.filter((it) =>
                    arr.includes(it.id),
                  );
                  diffSelect.forEach((it) => {
                    this.$refs.crud2.toggleRowSelection(it, false);
                  });
                  arr.forEach(
                    (it) =>
                      (this.spareResourcesObj.trIds =
                        this.spareResourcesObj.trIds.replace(it, '')),
                  );
                  this.idList = this.spareResourcesObj.trIds.split('\n');
                  let errorMsg = '已清除不合格人员' + arr.length + '人';
                  this.$message.error(errorMsg);
                  if (this.spareResourcesObj.trIds.startsWith('\n')) {
                    this.spareResourcesObj.trIds =
                      this.spareResourcesObj.trIds.substr(1);
                  }
                  if (this.spareResourcesObj.trIds.endsWith('\n')) {
                    this.spareResourcesObj.trIds =
                      this.spareResourcesObj.trIds.substr(
                        0,
                        this.spareResourcesObj.trIds.length - 1,
                      );
                  }
                  this.spareResourcesObj.trIds =
                    this.spareResourcesObj.trIds.replace(/\n+/g, '\n');
                  this.handleTextareaInput({
                    target: { value: this.spareResourcesObj.trIds },
                  });
                } else {
                  addTaskReserveTr({
                    flowId: this.flowId,
                    taskType: this.spareResourcesObj.taskType,
                    trIds: trIds,
                    staffId: this.userInfo.staffId,
                  }).then((res) => {
                    let data = res.data.data;
                    if (data > 0) {
                      this.dialogSpareResourcesVisible =
                        !this.dialogSpareResourcesVisible;
                      this.spareResourcesObj.taskType = null;
                      this.spareResourcesObj.trIds = '';
                      this.$message.success('添加备用译员成功！');
                    } else if (data === -1) {
                      this.$message.error('参数不全');
                    } else if (data === -2) {
                      this.$message.error(
                        '流程不是进行中状态，不能添加备用译员',
                      );
                    } else if (data === -3) {
                      this.$message.error('AI打标不允许操作此项！');
                    } else {
                      this.$message.error('添加备用译员失败！');
                    }
                  });
                  statistics(
                    Object.assign(
                      {
                        event_name: '添加备用资源',
                        event_type: 'click',
                        class_name: 'addTaskReserveTr',
                        class_url: '/dotadmin/dotRisk/addTaskReserveTr',
                        event_params:
                          '{flowId: this.flowId, taskType: this.spareResourcesObj.taskType, trIds: trIds, staffId: this.userInfo.staffId}',
                      },
                      this.staParams,
                    ),
                  );
                }
              });
            } else {
              this.$message.error('译员ID有重复,请修改后提交');
            }
          } else {
            this.$message.error(
              '如下译员ID格式有误,请修改后提交:  ' + '\n\r' + resultArr,
            );
          }
        } else {
          return false;
        }
      });
    },
    hideItemSubmit(formRef) {
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          hideFlow({
            userId: this.userInfo.staffId,
            flowId: this.flowId,
            remark: this.hideItemObj.remark,
            text: this.hideItemObj.taskType.join(),
          }).then((res) => {
            let data = res.data.data;
            if (data > 0) {
              // this.hideItemObj.taskType = null;
              this.$message.success('隐藏项目成功！');
              this.dialogHideItmeVisible = !this.dialogHideItmeVisible;
              this.toggoleHideFlag = true;
              this.hideItemObj.remark = '';
            } else if (data === -1) {
              this.$message.error('参数异常');
            } else if (data === -2) {
              this.$message.error('已经隐藏，不能再次隐藏');
            } else if (data === -3) {
              this.$message.error('流程状态已改变，不能操作');
            } else {
              this.$message.error('程序错误，隐藏失败');
            }
          });
          statistics(
            Object.assign(
              {
                event_name: '隐藏项目',
                event_type: 'click',
                class_name: 'hideFlow',
                class_url: '/dotadmin/dotRisk/hideFlow',
                event_params:
                  '{userId: this.userInfo.staffId, flowId: this.flowId, remark: this.hideItemObj.remark, text: this.hideItemObj.taskType.join()}',
              },
              this.staParams,
            ),
          );
        } else {
          return false;
        }
      });
    },

    addPriceSubmit(formRef) {
      if (this.addPriceObj.addType === 1 && this.addPriceObj.price == 0) {
        this.$message.error('价格不能为0');
        return false;
      } else if (
        this.addPriceObj.addType === 2 &&
        this.addPriceObj.afterPrice == 0
      ) {
        this.$message.error('价格不能为0');
        return false;
      }
      if (
        this.addPriceObj.addType === 2 &&
        this.addPriceObj.afterPrice <= this.addPriceObj.beforePrice
      ) {
        this.$message.error('调整后单价必须大于原始单价');
        return false;
      }
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          addTaskMaxAmount({
            staffId: this.userInfo.staffId,
            flowId: this.flowId,
            taskType: this.addPriceObj.priceType,
            addType: this.addPriceObj.addType,
            maxAmount:
              this.addPriceObj.addType === 1
                ? this.addPriceObj.price
                : this.addPriceObj.afterPrice,
          }).then((res) => {
            let data = res.data.data;
            if (data > 0) {
              this.dialogAddPriceVisible = !this.dialogAddPriceVisible;
              this.toggoleAddPriceFlag = !this.toggoleAddPriceFlag;
              this.riskInfoObj.isAddPrice = true;
              this.addPriceObj.price = null;
              this.addPriceObj.priceType = null;
              this.$message.success('加价成功！');
            } else if (data === -1) {
              this.$message.error('缺少参数');
            } else if (data === -2) {
              this.$message.error('流程不是进行中状态，不能设置任务加价！');
            } else if (data === -4) {
              this.$message.error('只能设置一次单价调整！');
            } else if (data === -5) {
              this.$message.error('AI打标不允许操作此项！');
            } else if (data === -3) {
              this.$message.error('非PE流程不能设置单价调整！');
            } else if (data === 0) {
              this.$message.error('增加任务加价上限金额失败！');
            }
          });
          statistics(
            Object.assign(
              {
                event_name: '自动加价',
                event_type: 'click',
                class_name: 'addTaskMaxAmount',
                class_url: '/dotadmin/dotRisk/addTaskMaxAmounte',
                event_params:
                  '{staffId: this.userInfo.staffId, flowId: this.flowId, taskType: this.addPriceObj.priceType, addType: this.addPriceObj.addType, maxAmount: this.addPriceObj.addType === 1 ? this.addPriceObj.price  : this.addPriceObj.afterPrice}',
              },
              this.statistics,
            ),
          );
        } else {
          return false;
        }
      });
    },
    spareResources(form, done) {
      this.dialogSpareResourcesVisible = true;
      this.idList = [];
      this.$nextTick(() => {
        this.$refs['spareResources'].resetFields();
      });
      this.selectionList = [];
    },
    toggoleAdd() {
      this.dialogAddPriceVisible = true;
      this.addPriceObj.addType = 1;
      this.addPriceObj.afterPrice = 0;
      orderAddList({
        orderId: this.orderId,
      }).then((res) => {
        this.orderAddListData = res.data.data;
        let map = this.orderAddListData
          .filter((it) => it.addType === 2)
          .map((it) => it.taskType);
        this.addPriceType.find((it) => it.value === 2).disabled =
          (map.includes(3) && map.includes(4)) || this.flowName === '打标';
        if (this.selectable.find((it) => it.value === 3)) {
          this.selectable.find((it) => it.value === 3).disabled =
            map.includes(3) && this.addPriceObj.addType === 2;
        }
        if (this.selectable.find((it) => it.value === 4)) {
          this.selectable.find((it) => it.value === 4).disabled =
            map.includes(4) && this.addPriceObj.addType === 2;
        }
      });
    },

    toggoleHide() {
      this.dialogHideItmeVisible = true;
      this.hideItemObj.taskType = null;
      // this.toggoleHideFlag = this.riskInfoObj.status === 3;
      hideFlowList({ flowId: this.flowId }).then((res) => {
        this.hideFlowListData = res.data.data;
        this.handleSelect2();
      });
      // this.$nextTick(() => {
      //   this.$refs["hideItem"].resetFields();
      // });
    },

    getPushNum(taskType) {
      queryPushTrNum({ orderId: this.orderId, taskType }).then((res) => {
        if (taskType === 1) {
          this.markFirstNum = res.data.data;
        } else if (taskType === 2) {
          this.markSecondNum = res.data.data;
        } else if (taskType === 3) {
          this.pePackageNum = res.data.data;
        } else if (taskType === 4) {
          this.peAuditPackageNum = res.data.data;
        }
      });
    },
    // 排序改变
    sortChange(column) {
      this.orderObj = {
        prop: column.prop,
        order: column.order,
      };
      if (!this.search.pending) {
        this.getList(this.page);
      }
    },
    // 排序改变
    sortChange2(column) {
      this.backupOrder = {
        prop: toLine(column.prop),
        order: column.order,
      };
      this.getList2(this.page2);
    },
    getLogList(page, params) {
      this.logTableLoading = true;
      logList(
        Object.assign(
          {
            pageNo: page.currentPage,
            pageSize: page.pageSize,
            flowId: this.flowId,
          },
          params,
        ),
      ).then((res) => {
        let logData = res.data.data;
        if (logData) {
          logData.records.forEach(
            (i) =>
              (i.createTime = formatDate(
                new Date(parseFloat(i.createTime)),
                'yyyy-MM-dd hh:mm',
              )),
          );
          this.logData = logData.records;
          this.logPage.total = logData.total;
          this.logTableLoading = false;
        } else {
          this.logData = [];
          this.logPage.total = 0;
          this.logTableLoading = false;
        }
      });
    },
    // 日志新增
    logSave(row, done, loading) {
      addLog(
        Object.assign({
          flowId: this.flowId,
          userId: this.userInfo.staffId,
          remark: row.remark,
        }),
      )
        .then((res) => {
          // 操作日志
          if (res.data.data && res.data.data > 0) {
            this.getLogList(this.logPage);
          }
          done();
          this.$notify.success('日志新增成功');
        })
        .catch(() => {
          this.$notify.error('日志新增失败');
          loading();
        });
    },
    getStatus(value) {
      if (value > 0) {
        return '置顶';
      } else if (value === 0) {
        return '';
      } else {
        return '置底';
      }
    },
    getType(value) {
      if (value > 0) {
        return 'success';
      } else if (value === 0) {
        return 'info';
      } else {
        return 'warning ';
      }
    },
    formatDate(time) {
      let date = new Date(parseFloat(time));
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    },
    // 获取当前时间
    getNowFormatDate() {
      let date = new Date();
      let year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      let hours =
        date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      let minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      );
    },
    // 刷新风险
    refreshRisk() {
      this.refreshText = '刷新中...';
      this.refreshLoading = true;
      updateRisk().then((res) => {
        setTimeout(() => {
          this.refreshText = this.getNowFormatDate() + ' 已刷新';
          this.refreshLoading = false;
        }, 3000);
      });

      capacityStatistics().then((res) => {
        setTimeout(() => {
          this.pendPeNum = res.data.data.pendPeNum;
          this.pendAuditNum = res.data.data.pendAuditNum;
          this.activeNum = res.data.data.activeNum;
          this.activeTwoNum = res.data.data.activeTwoNum;
        }, 2000);
      });
      statistics(
        Object.assign(
          {
            event_name: '刷新风险',
            event_type: 'click',
            class_name: 'updateRisk',
            class_url: '/dotadmin/dotRisk/updateRisk',
          },
          this.staParams,
        ),
      );
    },
    // 置顶项目
    toggoleItem() {
      this.toggoleItemFlag = !this.toggoleItemFlag;
      if (!this.toggoleItemFlag) {
        topFlow(
          Object.assign({
            userId: this.userInfo.staffId,
            flowId: this.flowId,
          }),
        )
          .then((res) => {
            if (res.data.data > 0) {
              this.$notify({
                title: '成功',
                message: this.toggoleItemText1 + '成功，页面已刷新',
                type: 'success',
              });
            } else if (res.data.data === -1) {
              this.$message.error('已处理过');
            } else {
              this.$message.error('未知错误，请联系管理员');
            }
          })
          .then(() => {
            this.getList(this.page);
            this.getLogList(this.logPage);
          });
        statistics(
          Object.assign(
            {
              event_name: '置顶项目',
              event_type: 'click',
              class_name: 'topFlow',
              class_url: '/dotadmin/dotRisk/topFlow',
              event_params:
                '{userId: this.userInfo.staffId, flowId: this.flowId}',
            },
            this.staParams,
          ),
        );
      } else {
        cancelSort(
          Object.assign({
            userId: this.userInfo.staffId,
            flowId: this.flowId,
            type: 1,
          }),
        )
          .then((res) => {
            this.$notify({
              title: '成功',
              message: this.toggoleItemText2 + '成功，页面已刷新',
              type: 'success',
            });
          })
          .then(() => {
            this.getList(this.page);
            this.getLogList(this.logPage);
          });
        statistics(
          Object.assign(
            {
              event_name: '取消置顶',
              event_type: 'click',
              class_name: 'cancelSort',
              class_url: '/dotadmin/dotRisk/cancelSort',
              event_params:
                '{userId: this.userInfo.staffId, flowId: this.flowId, type: 1}',
            },
            this.staParams,
          ),
        );
      }
    },
    // 置底任务
    toggoleTask() {
      this.toggoleTaskFlag = !this.toggoleTaskFlag;
      if (!this.toggoleTaskFlag) {
        bottomFlow(
          Object.assign({
            userId: this.userInfo.staffId,
            flowId: this.flowId,
          }),
        )
          .then((res) => {
            if (res.data.data > 0) {
              this.$notify({
                title: '成功',
                message: this.toggoleTaskText1 + '成功，页面已刷新',
                type: 'success',
              });
            } else if (res.data.data === -1) {
              this.$message.error('已处理过');
            } else {
              this.$message.error('未知错误，请联系管理员');
            }
          })
          .then(() => {
            this.getList(this.page);
            this.getLogList(this.logPage);
          });
        statistics(
          Object.assign(
            {
              event_name: '置底任务',
              event_type: 'click',
              class_name: 'bottomFlow',
              class_url: '/dotadmin/dotRisk/bottomFlow',
              event_params:
                '{userId: this.userInfo.staffId, flowId: this.flowId}',
            },
            this.staParams,
          ),
        );
      } else {
        cancelSort(
          Object.assign({
            userId: this.userInfo.staffId,
            flowId: this.flowId,
            type: 2,
          }),
        )
          .then((res) => {
            this.$notify({
              title: '成功',
              message: this.toggoleTaskText2 + '成功，页面已刷新',
              type: 'success',
            });
          })
          .then(() => {
            this.getList(this.page);
            this.getLogList(this.logPage);
          });
        statistics(
          Object.assign(
            {
              event_name: '取消置底',
              event_type: 'click',
              class_name: 'cancelSort',
              class_url: '/dotadmin/dotRisk/cancelSort',
              event_params:
                '{userId: this.userInfo.staffId, flowId: this.flowId, type: 2}',
            },
            this.staParams,
          ),
        );
      }
    },
    // 导航栏
    handleClick(val) {
      if (val === 'first') {
        setTimeout(() => {
          this.$refs?.zkStatistics?.init();
        }, 0);
        // 任务进度
        taskNumList(
          Object.assign({
            flowId: this.flowId,
          }),
        ).then((res) => {
          if (res.data) {
            this.taskData = res.data.data;
            if (this.taskData.length > 0) {
              this.taskData.forEach((it) => {
                this.getPushNum(it.taskType);
              });
            }
          }
        });
      } else if (val === 'second') {
        // 订单详情
        taskInfoByFlowId(
          Object.assign({
            flowId: this.flowId,
          }),
        ).then((res) => {
          if (res.data.data) {
            let obj = jsonFlatten(res.data.data);
            obj.createTime = formatDate(
              new Date(parseFloat(obj.createTime)),
              'yyyy-MM-dd hh:mm:ss',
            );
            obj.limitTime = formatDate(
              new Date(parseFloat(obj.limitTime)),
              'yyyy-MM-dd hh:mm:ss',
            );
            this.detailObj = obj;
          }
        });
      } else {
        // 操作日志
        this.getLogList(this.logPage);
      }
    },

    // 右边弹窗关闭方法
    handleClose(done) {
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
      done();
    },

    // 单元格样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 10) {
        if (row.riskLevel === 5) {
          return {
            backgroundColor: '#FF2525',
          };
        } else if (row.riskLevel === 4) {
          return {
            backgroundColor: '#FF6200',
          };
        } else if (row.riskLevel === 3) {
          return {
            backgroundColor: '#FCCA00 ',
          };
        } else if (row.riskLevel === 2) {
          return {
            backgroundColor: '#27B148',
          };
        } else if (row.riskLevel === 1) {
          return {
            backgroundColor: '#00C7FF',
          };
        }
      }
    },

    tagClick(
      data,
      type,
      sortTime,
      orderId,
      flowName,
      flowLevel,
      orderFlow,
      orderFlowName,
    ) {
      if (type === 1) {
        this.$message({
          message: '复制成功，内容为：' + data,
          type: 'success',
        });
        let input = document.createElement('input'); // js创建一个input输入框
        input.value = data; // 将需要复制的文本赋值到创建的input输入框中，this.ruleForm.url这个是我要复制的内容
        document.body.appendChild(input); // 将输入框暂时创建到实例里面
        input.select(); // 选中输入框中的内容
        document.execCommand('Copy'); // 执行复制操作
        document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
      } else {
        if (sortTime > 0) {
          this.toggoleItemFlag = false;
          this.toggoleTaskFlag = true;
        } else if (sortTime === 0) {
          this.toggoleItemFlag = true;
          this.toggoleTaskFlag = true;
        } else {
          this.toggoleItemFlag = true;
          this.toggoleTaskFlag = false;
        }
        this.flowId = data;
        this.flowName = flowName;
        this.orderFlowName = orderFlowName;
        // 每次还原到总价模式
        this.addPriceObj.addType = 1;
        this.addPriceType.find((it) => it.value === 2).disabled =
          flowName === '打标';
        // 是否自动加价
        orderAddList({
          orderId: orderId,
        }).then((res) => {
          this.orderAddListData = res.data.data;
          if (this.orderAddListData && this.orderAddListData.length > 0) {
            this.riskInfoObj.isAddPrice = true;
          }
        });
        getScoureStatus({
          orderId: orderId,
          taskType: 3,
        }).then((res) => {
          let code = res.data?.data;
          this.peFlag = code < 0;
        });
        if (flowLevel == 5) {
          this.getCreditScore(orderId, 3);
          this.getCreditScore(orderId, 4);
        } else if (flowName == '打标') {
          this.getCreditScore(orderId, 2);
        } else if (flowLevel == 3) {
          this.getCreditScore(orderId, 3);
        } else if (flowLevel == 4) {
          this.getCreditScore(orderId, 4);
        }
        // 是否已开启隐藏项目
        hideFlowList({ flowId: this.flowId }).then((res) => {
          this.hideFlowListData = res.data.data;
          this.handleSelect2();
          this.toggoleHideFlag =
            this.hideFlowListData && this.hideFlowListData.length > 0;
        });
        // 任务进度
        taskNumList(
          Object.assign({
            flowId: this.flowId,
          }),
        )
          .then((res) => {
            if (res.data) {
              this.taskData = res.data.data;
              if (this.taskData.length > 0) {
                this.taskData.forEach((it) => {
                  this.getPushNum(it.taskType);
                });
              }
            }
          })
          .then(() => {
            // 订单详情
            taskInfoByFlowId(
              Object.assign({
                flowId: data,
              }),
            ).then((res) => {
              if (res.data.data) {
                let obj = jsonFlatten(res.data.data);
                obj.createTime = formatDate(
                  new Date(parseFloat(obj.createTime)),
                  'yyyy-MM-dd hh:mm:ss',
                );
                obj.limitTime = formatDate(
                  new Date(parseFloat(obj.limitTime)),
                  'yyyy-MM-dd hh:mm:ss',
                );
                this.detailObj = obj;
                let num = this.taskData.reduce((pr, cu) => {
                  return cu.pendingNum + pr;
                }, 0);
                // 可领包为0
                this.numFlag = num === 0;
              }
            });
          });
        // 风险详情
        riskInfoByFlowId(
          Object.assign({
            flowId: data,
          }),
        ).then((res) => {
          if (res.data.data.flowLevel === 3) {
            this.detailOption.group = [
              {
                label: '',
                column: [
                  {
                    label: '轻任务订单号',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    disabled: true,
                    labelWidth: 130,
                    width: 310,
                    prop: 'orderId',
                    searchLabelWidth: 130,
                    span: 12,
                  },
                  {
                    label: '来源ID',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    width: 310,
                    prop: 'sourceId',
                    span: 12,
                  },
                  {
                    label: '任务总字数',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'totalWords',
                  },
                  {
                    label: '客户名称',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'custName',
                  },
                  {
                    label: '发起人',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    disabled: true,
                    prop: 'pmName',
                    labelWidth: 130,
                  },
                  {
                    label: '语种',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'slan',
                  },
                  {
                    label: '任务创建时间',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'createTime',
                  },
                  {
                    label: '任务截止时间',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    formslot: true,
                    labelslot: true,
                    disabled: true,
                    labelWidth: 130,
                    prop: 'limitTime',
                  },
                ],
              },
              {
                label: 'PE设置',
                prop: 'tksq',
                column: [
                  {
                    label: 'PE价格',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    formslot: true,
                    labelslot: true,
                    append: '元/千字',
                    prop: 'pePrice',
                  },
                  {
                    label: '最长处理时长',
                    labelPosition: 'left',
                    className: 'formClassName3',
                    disabled: true,
                    prop: 'maxPeTime',
                    formslot: true,
                    labelslot: true,
                    append: '秒/字',
                    labelWidth: 130,
                  },
                  {
                    label: '打回修改限制时长',
                    labelPosition: 'left',
                    className: 'formClassName3',
                    formslot: true,
                    labelslot: true,
                    disabled: true,
                    labelWidth: 130,
                    append: '小时',
                    prop: 'modifyLimitTime',
                  },
                ],
              },
            ];
          }
          if (res.data.data.flowLevel === 4 || res.data.data.flowLevel === 5) {
            this.detailOption.group = [
              {
                label: '',
                column: [
                  {
                    label: '轻任务订单号',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    disabled: true,
                    labelWidth: 130,
                    width: 310,
                    prop: 'orderId',
                    searchLabelWidth: 130,
                    span: 12,
                  },
                  {
                    label: '来源ID',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    width: 310,
                    prop: 'sourceId',
                    span: 12,
                  },
                  {
                    label: '任务总字数',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'totalWords',
                  },
                  {
                    label: '客户名称',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'custName',
                  },
                  {
                    label: '发起人',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    disabled: true,
                    prop: 'pmName',
                    labelWidth: 130,
                  },
                  {
                    label: '语种',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'slan',
                  },
                  {
                    label: '任务创建时间',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'createTime',
                  },
                  {
                    label: '任务截止时间',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    formslot: true,
                    labelslot: true,
                    disabled: true,
                    labelWidth: 130,
                    prop: 'limitTime',
                  },
                ],
              },
              {
                label: 'PE审核设置',
                prop: 'yhxx',
                column: [
                  {
                    label: 'PE审核价格',
                    labelPosition: 'left',
                    className: 'formClassName5',
                    disabled: true,
                    labelWidth: 130,
                    formslot: true,
                    labelslot: true,
                    append: '元/千字',
                    prop: 'peAuditPrice',
                  },
                  {
                    label: '最长处理时长',
                    labelPosition: 'left',
                    className: 'formClassName3',
                    disabled: true,
                    formslot: true,
                    labelslot: true,
                    prop: 'maxPeAuditTime',
                    append: '秒/字',
                    labelWidth: 130,
                  },
                ],
              },
            ];
          }
          if (res.data?.data?.flowLevel === 5) {
            this.detailOption.group = [
              {
                label: '',
                column: [
                  {
                    label: '轻任务订单号',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    disabled: true,
                    labelWidth: 130,
                    width: 310,
                    prop: 'orderId',
                    searchLabelWidth: 130,
                    span: 12,
                  },
                  {
                    label: '来源ID',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    width: 310,
                    prop: 'sourceId',
                    span: 12,
                  },
                  {
                    label: '任务总字数',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'totalWords',
                  },
                  {
                    label: '客户名称',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'custName',
                  },
                  {
                    label: '发起人',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    disabled: true,
                    prop: 'pmName',
                    labelWidth: 130,
                  },
                  {
                    label: '语种',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'slan',
                  },
                  {
                    label: '任务创建时间',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    prop: 'createTime',
                  },
                  {
                    label: '任务截止时间',
                    labelPosition: 'left',
                    className: 'formClassName2',
                    formslot: true,
                    labelslot: true,
                    disabled: true,
                    labelWidth: 130,
                    prop: 'limitTime',
                  },
                ],
              },
              {
                label: 'PE设置',
                prop: 'tksq',
                column: [
                  {
                    label: 'PE价格',
                    labelPosition: 'left',
                    className: 'formClassName',
                    disabled: true,
                    labelWidth: 130,
                    formslot: true,
                    labelslot: true,
                    append: '元/千字',
                    prop: 'pePrice',
                  },
                  {
                    label: '最长处理时长',
                    labelPosition: 'left',
                    className: 'formClassName3',
                    disabled: true,
                    prop: 'maxPeTime',
                    formslot: true,
                    labelslot: true,
                    append: '秒/字',
                    labelWidth: 130,
                  },
                  {
                    label: '打回修改限制时长',
                    labelPosition: 'left',
                    className: 'formClassName3',
                    formslot: true,
                    labelslot: true,
                    disabled: true,
                    labelWidth: 130,
                    append: '小时',
                    prop: 'modifyLimitTime',
                  },
                ],
              },
              {
                label: 'PE审核设置',
                prop: 'yhxx',
                column: [
                  {
                    label: 'PE审核价格',
                    labelPosition: 'left',
                    className: 'formClassName5',
                    disabled: true,
                    labelWidth: 130,
                    formslot: true,
                    labelslot: true,
                    append: '元/千字',
                    prop: 'peAuditPrice',
                  },
                  {
                    label: '最长处理时长',
                    labelPosition: 'left',
                    className: 'formClassName3',
                    disabled: true,
                    formslot: true,
                    labelslot: true,
                    prop: 'maxPeAuditTime',
                    append: '秒/字',
                    labelWidth: 130,
                  },
                ],
              },
            ];
          }
          if (res.data?.data && res.data.data.dotFlowRisk) {
            this.riskInfoObj = res.data.data;
          } else {
            this.riskInfoObj.flowLevel = res.data.data.flowLevel;
            this.riskInfoObj.status = res.data.data.status;
            this.riskInfoObj.riskLevel = res.data.data.riskLevel;
            this.riskInfoObj.totalRisk = res.data.data.totalRisk;
            for (let k in this.riskInfoObj.dotFlowRisk) {
              this.riskInfoObj.dotFlowRisk[k] = 0;
            }
          }
        });
        this.drawer = true;
        this.orderFlow = orderFlow;
        this.flowLevel = flowLevel;
        this.orderId = orderId;
        setTimeout(() => {
          this.$refs?.zkStatistics?.init();
        }, 0);
        statistics(
          Object.assign(
            {
              event_name: '订单详情',
              event_type: 'click',
            },
            this.staParams,
          ),
        );
      }
    },

    // 获取信用分
    getCreditScore(orderId, type) {
      getScore({
        orderId: orderId,
        taskType: type,
      }).then((res) => {
        if (type == 2) {
          this.tagScore = res.data?.data;
        } else if (type == 3) {
          this.peScore = res.data?.data;
        } else if (type == 4) {
          this.reviewScore = res.data?.data;
        }
      });
    },

    detailSubmit(form, done) {
      done();
    },
    error(err) {
      // this.$message.success('请查看控制台');
    },
    headerCell(row, column, rowIndex, columnIndex) {
      return 'test';
    },
    getList(page, params) {
      this.tableLoading = true;
      let language = this.search.language
        ? this.search.language.split(',')
        : ['', ''];
      taskList(
        Object.assign(
          {
            text: this.search.text,
            pmId: this.search.pmId,
            slan: language[0],
            tlan: language[1],
            sortType: this.search.sortType,
            riskLevel: this.search.riskLevel,
            autoType: this.search.autoType,
            fieldCode: this.search.fieldCode,
            qcId: this.search.qcId,
            pageNo: page.currentPage,
            pageSize: page.pageSize,
          },
          params,
          this.orderObj,
        ),
      )
        .then((res) => {
          let records = res.data.data.records;
          // this.search.pending = false;
          records.forEach(
            (it) => (it.list = it.list.filter((item) => item.qcId !== null)),
          );
          this.tableData = records;
          this.tempData = JSON.stringify(this.tableData);
          if (this.search.pending) {
            this.tableData = JSON.parse(this.tempData).filter(
              (it) => !(it.pePendingNum === 0 && it.peAuditPendingNum === 0),
            );
          } else {
            this.tableData = JSON.parse(this.tempData);
          }
          this.page.total = res.data.data.total;
          this.tableLoading = false;
        })
        .then(() => {
          projectStausEmun().then((res) => {
            this.tableOption.column[7].dicData = res.data.data;
          });
        });
    },
    searchChange(form, done) {
      this.page.currentPage = 1; //避免翻页了再搜索为空的情况，明明应该有数据
      this.getList(this.page, form);
      done();
      statistics(
        Object.assign(
          {
            event_name: '搜索',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    currentChange(current) {
      this.page.currentPage = current;
    },
    logSizeChange(pageSize) {
      this.logPage.pageSize = pageSize;
    },
    logCurrentChange(current) {
      this.logPage.currentPage = current;
    },
    refreshChange() {
      this.getList(this.page);
    },
    update(row, index, done, loading) {
      putObj(this.form)
        .then(() => {
          this.getList(this.page);
          done();
          this.$notify.success('修改成功');
        })
        .catch(() => {
          loading();
        });
    },
  },
  beforeMount() {
    listByRoleCode(
      Object.assign({
        roleCode: 'DOT_PM',
      }),
    ).then((res) => {
      let result = res.data.data;
      this.pmOptions = result.map((it) => {
        return {
          value: it.staffId,
          // label: it.username
          label: it.realname,
          username: it.username,
        };
      });
    });
  },

  watch: {
    drawer(val) {
      if (!val) {
        this.activeName = 'first';
      }
    },
  },
};
</script>
<style scoped>
.item {
  margin-top: 10px;
  margin-right: 40px;
}
.row-first {
  padding: 30px;
}
.row-second {
  padding-left: 30px;
  font-weight: bold;
}
.row-total {
  color: #00bfbf;
}
.bread-left {
  padding-left: 20px;
}
.button-bottom {
  padding: 24px;
  display: flex;
  justify-content: space-between;
}
.test {
  font-size: 14px;
  background-color: #b4c7e27a !important;
}
</style>
<style lang="scss" scoped>
:deep(.form-detail) {
  padding-top: 40px;
}
:deep(.el-form-item--mini.el-form-item),
:deep(.el-form-item--small.el-form-item) {
  margin-bottom: 0;
}
:deep(.avue-form__group) {
  padding-top: 20px;
}
:deep(.badge-item) {
  position: relative;
  bottom: 9px;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  text-align: center;
  border-radius: 4px;
}
:deep(.red) {
  color: red;
}
:deep(.self_defined .el-collapse-item__content .avue-form__menu--center) {
  text-align: left;
}
:deep(.el-collapse-item__content .avue-form__menu) {
  padding: 0 0 0 30px;
}
:deep(.self_defined .el-collapse-item__content .el-col-md-24) {
  width: auto;
}
:deep(.el-collapse-item__content .el-col-md-24) {
  padding-bottom: 10px;
}
:deep(.avue-group__title) {
  font-weight: 600;
}
:deep(#backupList .el-form) {
  max-height: 400px;
  overflow: auto;
}
:deep(#backupListDialog .el-dialog--center .el-dialog__body) {
  padding: 0 25px 30px;
}
:deep(.green) {
  color: green !important;
}
.grey-font {
  font-size: 10px;
  color: darkgrey;
}
.edit {
  display: flex;
  height: 350px;
}
#leftBox {
  width: 40px;
  height: 100%;
  text-align: left;
}
#edit-content {
  padding: 10px 8px;
  width: 100%;
  height: 100%;
  font-size: 12px;
  line-height: 24px;
  color: black;
  font-family: inherit;
  border: 1px solid #eaeaea;
  background: rgb(255, 255, 255);
  box-sizing: border-box;
  outline: none;
  resize: none;
}
#leftNum {
  padding: 10px 4px;
  height: 100%;
  width: 100%;
  line-height: 24px;
  font-size: 12px;
  text-align: right;
  color: #999;
  font-weight: bold;
  resize: none;
  outline: none;
  overflow-y: hidden;
  overflow-x: hidden;
  border: 0;
  background: rgba(199, 208, 220, 1);
  box-sizing: border-box;
}
</style>
